<template>
  <div>
    <div v-if="page.cnt > 0" class="pagination catalog__pagination">
      <span class="pagination-header xs-hide">Страницы: </span>
      <a href="#1" class="pagination__item" :disabled="pages.current === 1"
         :class="{'disabled':pages.current === 1}"
         @click="toPage(1)">
        <span class="pagination__item-icon icon icon-arrow-left"></span>
      </a>

      <template v-for="n in pageCount">

        <template v-if="n != pageCenter">
          <a class="pagination__item"
             v-if="pages.current - pageCenter + n > 0 && pages.current - pageCenter + n <= pages.last"
             :href="'#' + (pages.current - pageCenter + n )"
             @click="toPage(pages.current - pageCenter + n)">
            <span>{{ pages.current - pageCenter + n }}</span>
          </a>
        </template>
        <template v-else>
          <span class="pagination-monitor">{{ pages.current }}</span>
        </template>

      </template>


      <a :href="'#' + pages.last" class="pagination__item"
         :disabled="pages.current == pages.last"
         :class="{'disabled':pages.current == pages.last}"
         @click="toPage(pages.last)">
        <span class="pagination__item-icon icon icon-arrow-right"></span>
      </a>

      <div class="pagination_other">
        <span class="pagination__item-icon icon icon-arrow-bottom"></span>
        <div class="pagination_menu">
          <input type="text" class="pagination-monitor pagination__input" :value="(pages.current + 1)">
          <ul class="">
            <li v-for="pageItem in pages.last">
              <a :href="'#' + pageItem"
                 @click="toPage(pageItem)">
                <span v-if="pageItem == pages.current" class="active">{{ pageItem }}</span>
                <span v-else>{{ pageItem }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="loader-mini" :class="{'active': isLoading}"></div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      pages: {
        current: 1,
        last: 1,
        perPage: 20
      },
      isLoading: false,
      pageCount: window.innerWidth >= 620 ? 9 : 5
    }
  },

  computed: {
    page() {
      return this.$store.getters.page;
    },
    pageCenter() {
      return Math.round(this.pageCount / 2)
    }
  },

  methods: {
    toPage: function (pageNum) {
      this.$store.dispatch('SET_SETTINGS', {page: {current: pageNum, perPage: this.page.page.perPage}});
      this.$store.dispatch('UPDATE_STORE');
      this.isLoading = true;
    }
  },
  watch: {
    page(val) {
      this.pages.current = val.page.current;
      this.pages.perPage = val.page.perPage;
      if (this.page.cnt){
        this.pages.last = Math.ceil(this.page.cnt / val.page.perPage);
      }
      this.isLoading = false;
      //позиционирование в начало каталога
      document.querySelector('.catalog__controls').scrollIntoView();
    },
  },
}
</script>

<style scoped>

</style>